/**
 * Deprecation cutover: `/dashboard` → manifest-backed render Control Bridge.
 * Preserves query string for local-bridge session handoff.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { controlBridgeHomeHref } from '../../utils/controlBridgeRoutes';

export const DashboardLegacyRedirect: React.FC = () => {
  const location = useLocation();
  return <Navigate to={controlBridgeHomeHref(location.search)} replace />;
};

export default DashboardLegacyRedirect;
